export default __webpack_public_path__ + "static/cloud-68175dbaf77562966763ffe4936fd440.svg";